<template>
    <category-layout>

        <template slot="header">
            <div class="breadcrumb" v-if="categoryNode">
                <span class="crumb"><router-link :to="{ name: 'home' }">Sākums</router-link></span>
                <span class="crumb" v-for="p in categoryNode.path">
                    <router-link :to="{ name: 'category', params: { categoryNodeId: p.id } }" :key="p.id">{{p.category.title}}</router-link>
                </span>
                <span class="crumb">{{ title }}</span>
            </div>
            <h1 class="category-title">{{ title }}</h1>
            <h4 class="category-subtitle" v-if="description">{{ description }}</h4>
        </template>

        <div class="theme-list row small-up-2 medium-up-3 large-up-5">
            <div class="column" v-for="categoryNode in subCategoryNodes">
                <category-item
                        :linkTo="categoryLink(categoryNode)"
                        :title="categoryNode.category.title"
                        :icon="categoryNode.category.icon_url"
                        :count="categoryNode.category.materials_count"></category-item>
            </div>
        </div>

        <div v-if="materials && materials.length > 0" class="row column materials-browser">
            <hr/>

            <div class="file-list-container row small-up-2 medium-up-3 large-up-4">
                <spinner v-if="loading === true" class="spinner"></spinner>
                <div v-else class="column" v-for="material in materials">
                    <material-item :material="material"></material-item>
                </div>
            </div>

            <div v-if="materials.length > 0" class="pagination-container">
                <pagination :current.sync="page" :total="totalPages"></pagination>
            </div>
        </div>
    </category-layout>
</template>

<script>
    import CategoryLayout from '../layouts/CategoryLayout.vue'
    import CategoryItem from '../components/CategoryItem.vue'
    import MaterialItem from '../components/MaterialItem'
    import Pagination from '../components/common/Pagination'
    import categories from '../api/categories'
    import materials from '../api/materials'


    export default {

        created() {
            this.getCategory()
        },

        props: ['categoryNodeId'],

        data() {
            return {
                categoryNode: null,
                title: '',
                description: '',
                subCategoryNodes: [],
                materials: [],
                sort: 'created_at',
                totalPages: 1,
                page: 1,
                loading: false
            }
        },

        methods: {
            getCategory() {
                //TODO lookup in store
                categories.find(this.categoryNodeId)
                    .then((response) => {
                        this.categoryNode = response.data;
                        this.title = this.categoryNode.category.title;
                        this.description = this.categoryNode.category.description;
                        this.subCategoryNodes = this.categoryNode.children;
                    })
            },

            /**
             * Get materials for current category node considering all parent categories.
             * Set total page count and current page index.
             */
            getMaterials() {
                this.loading = true;
                materials.get({ categories: this.categories.map(c => c.id), page: this.page, sort: this.sort })
                    .then(response => {
                        this.materials = response.data.data;
                        this.totalPages = response.data.meta ? response.data.meta.last_page : 1;
                        this.page = response.data.meta ? response.data.meta.current_page : 1;
                        this.loading = false
                    });
            },

            categoryLink(categoryNode) {
                if (!categoryNode.children || categoryNode.children.length === 0) {
                    return { name: 'category-materials', params: { categoryNodeId: categoryNode.id } }
                } else {
                    return { name: 'category', params: { categoryNodeId: categoryNode.id } }
                }
            },

            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))//Resetting component data
            }
        },

        computed: {
            /**
             * Get all parent category ids. Including the current category.
             * @returns {Array}
             */
            categories: function () {
                if (this.categoryNode === null) return [];

                const c = this.categoryNode.path.map(categoryNode => categoryNode.category);
                return [this.categoryNode.category].concat(c);
            },
        },

        watch: {
            categoryNodeId: function (val, oldVal) {
                if (val !== 'undefined' && (oldVal === null || val !== oldVal)) {
                    this.getCategory()
                } else {
                    this.reset()
                }
            },

            categoryNode: function(val, oldVal) {
                console.log('categoryNode has changed', val, oldVal);

                if (val === null) {
                    this.materials = [];
                    this.totalPages = 1;
                    this.page = 1;
                } else if (oldVal === null || val.id !== oldVal.id) {
                    this.getMaterials();
                }
            },

            page: function (val, oldVal) {
                console.log('page has changed', val, oldVal);
                this.getMaterials()
            }
        },

        components: { CategoryItem, CategoryLayout, Pagination, MaterialItem }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";

    .breadcrumb {
        color: white;
        font-size: px-em(12px);
    }

    .file-list-container {
        padding-bottom: 1.875rem;
    }

    .category-subtitle {
        color: white;
        margin-top: -0.8em;
    }

    .pagination-container {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/SubCategories.vue